<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';

    const props = withDefaults(
        defineProps<{
            defaultValue?: string | number;
            modelValue?: string | number;
            rows?: number;
            class?: HTMLAttributes['class'];
        }>(),
        {
            rows: 3,
        },
    );

    const emits = defineEmits<{
        (e: 'update:modelValue', payload: string | number): void;
    }>();

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });
</script>

<template>
    <textarea
        v-model="modelValue"
        data-slot="textarea"
        :rows="rows"
        :class="
            cn(
                'placeholder:text-faded-foreground selection:bg-primary selection:text-primary-foreground border-input flex w-full min-w-0 rounded-md border bg-transparent px-2.5 py-1.5 text-xs shadow-xs transition-[color,box-shadow] outline-none placeholder:text-xs',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                'disabled:bg-faded disabled:pointer-events-none disabled:cursor-not-allowed',
                props.class,
            )
        "
    />
</template>
